export default "__VITE_ASSET__D5qzmQ7k__"